<template>
    <div :class="{ 'info-box': true, 'warning-box': warning}">
        <div class="box-icon">
            <icon :icon="['fal', 'exclamation-triangle']"/>
        </div>
        <div class="box-content">
            <slot/>
        </div>

    </div>
</template>

<script>
    export default {
        name: "InfoBox",
        props: {
            warning: Boolean
        },

    }
</script>

<style lang="scss" scoped>
    @import "../styles/global";
    .warning-box {
        background-color: mix($backgroundColor, $openRed, 50);
        border: 1px dashed var(--accent-color);
    }

    .box-icon {
        display: flex;
        align-content: center;
        align-items: center;
        padding: 2px 5px 2px 5px;
    }

    .info-box {
        display: flex;
        flex-flow: row;
        padding: 5px;
        margin-bottom: 5px;
        margin-top: 5px;
        border-radius: 5px;
    }

    .box-content {
        width: 100%;
        display: flex;
        align-content: center;
        align-items: center;
    }
</style>